import {
  FormattedHTMLMessage,
  defineMessages,
  injectIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { accountLogout } from '../../../../ducks/user/auth';
import { getImageUrl, navigate } from '../../../../helpers';
import { getPublicUser } from '../../../../ducks/users';
import { getTicketTypes, getTickets, postClaimFreeTicket } from '../../../../ducks/event';
import { isMobile } from '../../../../mobile/helpers';

import Flash from '../../components/Flash';
import Option from '../components/Option';
import styles from '../seatmap.scss';
import withUser from '../../../../components/withUser';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      referralId: PropTypes.string,
    }),
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  users: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  dispatch: PropTypes.func.isRequired,
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    logo_id: PropTypes.string,
    shortcode: PropTypes.string,
    purchase_url: PropTypes.string,
    seatmap_published: PropTypes.bool,
  }),
  loading: PropTypes.bool,
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
  })),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  ticketTypes: PropTypes.arrayOf(PropTypes.shape({
    filter: PropTypes.func,
  })),
};

const getQueryParam = (param) => {
  const result = window.location.search.match(
    new RegExp(`(\\?|&)${param}(\\[\\])?=([^&]*)`),
  );
  return result ? decodeURIComponent(result[3]) : false;
};

const messages = defineMessages({
  signRegTitle: {
    id: 'seatmap.manage.signRegTitle',
    defaultMessage: 'Sign in or register',
  },
  signRegDescription: {
    id: 'seatmap.manage.signRegDescription',
    defaultMessage: 'Sign in or register to view and manage your tickets.',
  },
  signOutTitle: {
    id: 'seatmap.manage.signOutTitle',
    defaultMessage: 'Sign out',
  },
  signOutDescription: {
    id: 'seatmap.manage.signOutDescription',
    defaultMessage: 'You are logged in as {userName}',
  },
  buyTicketsTitle: {
    id: 'seatmap.manage.buyTicketsTitle',
    defaultMessage: 'Buy tickets',
  },
  buyTicketsDescription: {
    id: 'seatmap.manage.buyTicketsDescription',
    defaultMessage: 'Jump to the ticket shop to purchase',
  },
  claimTicketsTitle: {
    id: 'seatmap.manage.claimTicketsTitle',
    defaultMessage: '{claimed, select, true {Claim free ticket (claimed)} other {Claim free ticket}}',
  },
  claimTicketsTitleNotLoggedIn: {
    id: 'seatmap.manage.claimTicketsTitleNotLoggedIn',
    defaultMessage: 'Claim free ticket (sign in below)',
  },
  notLoggedIn: {
    id: 'seatmap.manage.notLoggedIn',
    defaultMessage: 'You have to login first!',
  },
  brokenLinkMessage: {
    id: 'seatmap.referral.notfound.message.default',
    defaultMessage: 'Seems like the link you got is broken. The only advice I can get you is to ether go back to the source where you got the link or contact our support team below.',
  },
});

class Manage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      dispatch,
      user,
      event,
      tickets,
      match,
    } = this.props;

    if (user && user.id && event && !(tickets?.length > 0)) {
      dispatch(getTickets(event.id));
    }
    dispatch(getPublicUser(match.params.referralId));
    dispatch(getTicketTypes(event.id));
  }

  componentDidUpdate(prevProps) {
    const { event: oldEvent, user: oldUser } = prevProps;
    const {
      event,
      user,
      dispatch,
      match,
    } = this.props;

    if ((user !== oldUser) || (!oldEvent && event) || (oldEvent && oldEvent.id !== event.id)) {
      if (user) {
        dispatch(getTickets(event.id));
      }
      dispatch(getTicketTypes(event.id));
      dispatch(getPublicUser(match.params.referralId));
    }
  }

  render() {
    const {
      history,
      match,
      tickets,
      user,
      event,
      loading,
      dispatch,
      intl,
      ticketTypes,
      users,
    } = this.props;
    const {
      claimLoading,
    } = this.state;
    const { formatMessage } = intl;

    const selectedTicket = getQueryParam('t');
    const claimableTickets = ticketTypes && ticketTypes.filter(
      (item) => item.freeToClaim
        && !item.requireNotInvite
        && (!selectedTicket || selectedTicket === item.id),
    );

    const onClaimFreeTicket = (id) => () => {
      if (!user) {
        this.setState({ claimError: '' }, () => this.setState({ claimError: formatMessage(messages.notLoggedIn) }));
        return;
      }

      this.setState({ claimLoading: true });
      dispatch(postClaimFreeTicket(event.id, id, match.params.referralId))
        .finally(() => this.setState({ claimLoading: false }));
    };

    const trusted = users.getIn([match.params.referralId, 'trusted']);

    return (
      <>
        <Flash
          message={this.state.claimError}
          error
        />

        { !loading
          && (!users.getIn([match.params.referralId])
            || !trusted
            || !claimableTickets
            || claimableTickets?.length !== 1
          )
          && (
            <>
              <div className={styles.title}>
                {event.logo_id && <img src={getImageUrl(event.logo_id)} style={{ width: '100%' }} alt="logo" />}
              </div>
              <>
                <h1>Ooops!</h1>

                <div style={{ fontSize: 14 }}>{formatMessage(messages.brokenLinkMessage)}</div>
              </>
            </>
          )}

        { !loading
            && users.getIn([match.params.referralId])
            && trusted
            && claimableTickets
            && claimableTickets?.length === 1
            && (
              <>
                <div className={styles.title}>
                  {event.logo_id && <img src={getImageUrl(event.logo_id)} style={{ width: '100%' }} alt="logo" />}
                </div>

                <div className={styles.description}>
                  <FormattedHTMLMessage
                    id="seatmap.referral.description"
                    defaultMessage="<h1>{source}</h1> invites you to <strong>{eventName}</strong><br /><br />Get your ticket right away!"
                    values={{
                      source: users.getIn([match.params.referralId, 'name']),
                      eventName: event.name,
                    }}
                  />
                </div>


                {claimableTickets && claimableTickets.map((item) => {
                  const alreadyClaimed = tickets.find(
                    (ticket) => ticket.ticket_type_id === item.id,
                  ) !== undefined;

                  return (
                    <Option
                      key={item.id}
                      icon="hand-holding-heart"
                      title={formatMessage(
                        user ? messages.claimTicketsTitle : messages.claimTicketsTitleNotLoggedIn,
                        { claimed: alreadyClaimed },
                      )}
                      description={item.name}
                      disabled={alreadyClaimed || !user}
                      loading={claimLoading}
                      onClick={!alreadyClaimed ? onClaimFreeTicket(item.id) : undefined}
                    />
                  );
                })}
                {event.purchase_url
                && (
                <Option
                  key={event.id}
                  icon="shopping-basket"
                  title={formatMessage(messages.buyTicketsTitle)}
                  description={formatMessage(messages.buyTicketsDescription)}
                  href={event.purchase_url}
                />
                )}
                {((claimableTickets && claimableTickets?.length > 0) || event.purchase_url) && (
                  <div className={styles.divider} />
                )}
                { user && user.id
                  ? (
                    <Option
                      icon="sign-out"
                      title={formatMessage(messages.signOutTitle)}
                      description={formatMessage(
                        messages.signOutDescription,
                        { userName: user.name },
                      )}
                      onClick={isMobile() && window
                        ? window.logout : () => dispatch(accountLogout())}
                    />
                  )
                  : (
                    <Option
                      icon="sign-in"
                      title={formatMessage(messages.signRegTitle)}
                      description={formatMessage(messages.signRegDescription)}
                      onClick={() => navigate(history, `/login/${encodeURIComponent(btoa(`${match.url}?t=${selectedTicket}`))}`)}
                    />
                  )}
              </>
            )}
      </>
    );
  }
}

Manage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    users: state.getIn(['users', 'list']),
    users_error: state.getIn(['users', 'error']),
    event: state.getIn(['event', 'data']),
    ticketTypes: state.getIn(['event', 'ticket_types']),
    error: state.getIn(['event', 'error']),
    loading: state.getIn(['event', 'loading']) || state.getIn(['users', 'loading']),
    tickets: state.getIn(['event', 'tickets']),
  };
}

export default injectIntl(withUser(connect(mapStateToProps)(Manage)));
